import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

interface DialogData {
  url: string
}

@Component({
  selector: 'app-chat-cad-viewer',
  templateUrl: './chat-cad-viewer.component.html',
  styleUrls: ['./chat-cad-viewer.component.scss']
})
export class ChatCadViewerComponent implements OnInit {
  safeUrl: any
  loading: boolean = true;
  constructor(public dialogref: MatDialogRef<ChatCadViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sanitizer: DomSanitizer,
  ) {
    this.safeUrl = this.getSafeUrl(data.url);

  }

  ngOnInit(): void {
    window.open(this.data.url,
      "_blank"
    );
  }

  getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onIframeLoad(iframeRef: HTMLIFrameElement) {
    // Hide the loading overlay when iframe is loaded
    if (iframeRef?.src?.length > 0) {
      this.loading = false;
    }
  }

  closeDialog(){
    this.dialogref.close();
  }

}
